import { createAction, props } from '@ngrx/store';
import { ReportMenu } from '../../entities/report-menu.entity';

export const loadNavigation = createAction(
  '[Navigation] Load Navigation',
  props<{ role: string }>(),
);
export const loadNavigationSuccess = createAction(
  '[Navigation] Load Navigation Success',
  props<{ routes: ReportMenu[] }>(),
);
export const loadNavigationFailure = createAction(
  '[Navigation] Load Navigation Failure',
  props<{ error: any }>(),
);

// actions
export const selectRoute = createAction(
  '[Navigation] Select Route',
  props<{ route: ReportMenu }>(),
);

export const deselectRoute = createAction('[Navigation] Deselect Route');
